import React from 'react';
import classnames from 'classnames';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ProductionAccordion from '../ProductionAccordion';
import MoreButton from '../MoreButton';
import { TP } from '../../constants/consts';
import { useTranslation } from '../../src/i18n';
import InfiniteScrollPagination from '../InfiniteScrollPagination';
import ProductionDatesContent from '../ProductionDatesContent';
import { getGroupedProductionsDateForTheCard } from '../../utils/common';
import AppCircularProgress from '../AppCircularProgress/AppCircularProgress';
import FbTabsSection from '../FbTabsSection';
import { fontSize, colors } from '../../constants/styleConstants';
import TabPanel from '../TabPanel';
import EmptyStateCard from '../EmptyStateCard';

const useStyles = makeStyles(() => ({
  root: {
    fontFamily: 'Roboto',
  },
  cardsSection: {
    marginTop: 16,
  },
  dates: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 8,
  },
  appBarClass: {
    border: 0,
    borderBottom: `1px solid ${colors.contentDivider}`,
    padding: 0,
    marginTop: props => (props.tab === 'home' && props.page !== 'production' ? 0 : 15),
  },
  tabClasses: {
    fontSize: fontSize.basic,
    minWidth: 'fit-content',
    padding: '0 10px',
    textTransform: 'capitalize',
    minHeight: '40px',
    '& .MuiTab-wrapper': {
      color: '#555555',
      opacity: 0.5,
    },
  },
  tabsClasses: {
    minHeight: '40px',
  },
  loader: {
    marginTop: 50,
  },
}));

const StubPagePerformanceContent = ({
  performances,
  className,
  tab,
  isLoggedIn,
  viewAllPerformances,
  query,
  fetchPerformances,
  isLoading,
  hideViewPerformance,
  page,
  dates = [],
  pageView = 'production',
  profile,
  performanceTabs,
  selectedTab,
  onChangeTab,
}) => {
  const classes = useStyles({ tab, page });
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  const filteredPerformances = tab === 'home' ? performances?.data?.slice(0, isMobile ? 3 : 6) : performances?.data;

  // to push the dates in new array
  const datesObj = {
    dates,
  };
  const grouppedDates = getGroupedProductionsDateForTheCard(datesObj, false);

  const accordionComponent = (
    <ProductionAccordion
      hideViewPerformance={hideViewPerformance}
      viewType={pageView}
      productions={filteredPerformances}
      isLoggedIn={isLoggedIn}
      className={classes.cardsSection}
      page={page}
      profile={profile}
    />
  );

  return (
    <div className={classnames(classes.root, className)}>
      {/* display dates only for production stub page home tab  */}
      {page === 'production' && <ProductionDatesContent className={classes.dates} formattedDates={grouppedDates} />}

      {performanceTabs && (
        <FbTabsSection
          tabs={performanceTabs.filter(item => item.isShown)}
          appBarClass={classes.appBarClass}
          onChange={onChangeTab}
          initialTabValue={selectedTab}
          tabModel="normal"
          tabClasses={classes.tabClasses}
          tabsClasses={classes.tabsClasses}
        />
      )}
      <div>
        {performanceTabs.map((item, index) => (
          <TabPanel
            key={`${item.value}-${index}`}
            value={selectedTab}
            currentVal={item.value}
            className={classes.tabPanel}
          >
            <Grid item xs={12} md={12} sm={12}>
              {tab === 'home' ? (
                isLoading ? (
                  <AppCircularProgress size={30} className={classes.loader} />
                ) : isEmpty(filteredPerformances) ? (
                  <EmptyStateCard
                    message={`${t(`${TP}.FN_SORRY`)}!`}
                    subTextMessage={t(`${TP}.FN_NO_UPCOMING_PERFORMANCE`)}
                  />
                ) : (
                  accordionComponent
                )
              ) : isEmpty(filteredPerformances) && !isLoading ? (
                <EmptyStateCard
                  message={`${t(`${TP}.FN_SORRY`)}!`}
                  subTextMessage={t(`${TP}.FN_NO_UPCOMING_PERFORMANCE`)}
                />
              ) : (
                <InfiniteScrollPagination
                  isLoading={isLoading}
                  fetchFunction={pagination => fetchPerformances(query, pagination, pageView)}
                  filters={performances}
                >
                  {accordionComponent}
                </InfiniteScrollPagination>
              )}
            </Grid>
          </TabPanel>
        ))}
      </div>

      {/* Display more button only on home tab */}
      {tab === 'home' && filteredPerformances?.length > 0 && !isLoading && (
        <MoreButton
          className={classes.moreButton}
          buttonText={t(`${TP}.m_VIEW_ALL_PERFORMANCES`)}
          action={viewAllPerformances}
        />
      )}
    </div>
  );
};

StubPagePerformanceContent.propTypes = {};

export default StubPagePerformanceContent;
